export enum AnimationSlide {
  left = 'left',
  right = 'right',
}
